import React from "react";

class Contact extends React.Component {
	render() {
		return (
			<div>
				<div className="App-header">
					<h1>Contact Me</h1>
				</div>
				<main>
					<div className="Boxed">
						<p>
							<h2>Contact methods</h2>
							Contact me via email:
							<br></br>
							<a href="mailto:wrac4242@gmail.com">For general contact</a>
						</p>
					</div>
				</main>
			</div>
		);
	}
}

export default Contact;
